export default __webpack_public_path__ + "img/homepage-agile-cover.asset.3d9d274d.jpg";